<template>
  <div v-if="visibleOperate" class="personal-operate">
    <div class="personal-operate__repwd" @click="updatePwd">修改密码</div>
    <div class="personal-operate__agreement">
      <router-link to="/aigenai/doc/policy/agreement.html" target="_blank" style="color: #fff; text-decoration-line: none">用户协议</router-link>
    </div>
    <div class="personal-operate__privacy">
      <router-link to="/aigenai/doc/policy/privacy.html" target="_blank" style="color: #fff; text-decoration-line: none">隐私政策</router-link>
    </div>
    <div class="personal-operate__logout" @click="logout">退出登录</div>
  </div>
</template>
<script>
  export default {
    name: 'AI-Personal-Operate',
    props:{
      'visible':{
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        visibleOperate: !this.visible
      };
    },
    watch: {
      visible(newVal){
        this.visibleOperate = !newVal
      }
    },
    methods:{
      updatePwd() {
        this.$router.push({path: '/myAccount'}, ()=>{})
        // 关闭用户中心
        this.visibleOperate = false
        this.$bus.$emit('updateClose', true)
      },
      // 退出登录
      logout(){
        this.$http.post('/aigenai/logout', {userId: localStorage.getItem('userId')}).then(
          res=>{
            if (res.code !== 0) return
            this.visibleOperate = false
            this.$bus.$emit('updateClose', true)
            // 登录标识设置为false,未登录
            let userInfo = {logged: false}
            this.$store.commit('storeUserInfo', userInfo)
            this.$router.push({path:'/login'}, ()=>{})
            // 登出删除本地缓存
            localStorage.clear()
          }
        )
      }
    }
  }
</script>
<style lang="less" scoped>
.personal-operate {
  position: absolute;
  width: 180px;
  min-height: 200px;
  top: 64px;
  right: 0px;
  font-size: 14px;
  background-color: #171717;
  z-index: 1;
  :hover{
      background-color: #ffffff97;
  }
  &__repwd{
    margin: 10px 0 0 5px;
    padding: 5px 0 5px 5px;
    color: #fff;
    cursor: pointer;
  }
  &__agreement{
    margin: 10px 0 0 5px;
    padding: 5px 0 5px 5px;
    cursor: pointer;
  }
  &__privacy{
    margin: 10px 0 0 5px;
    padding: 5px 0 5px 5px;
    cursor: pointer;
  }
  &__logout{
    margin: 10px 0 10px 5px;
    padding: 10px 0 5px 5px;
    border-top: 1px solid #b7b1b19d;
    color: #fff;
    cursor: pointer;
  }
}
</style>
